import { Pipe, PipeTransform } from '@angular/core';
import { FormToSendModel } from 'src/app/core/models/form-to-send-model';

@Pipe({
  name: 'formFilterPipe'
})
export class FormFilterPipe implements PipeTransform {

  transform(list: FormToSendModel[], text?: string): any {

    if (!text) {
      return list;
    }

    return list.filter(x => {
      if (x.Name && x.Name.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        return true;
      }
      if (x.CategoryName && x.CategoryName.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        return true;
      }
      
      return false;
    });
  }

}
